import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Swal from "sweetalert2";
import Login from '../views/Login.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
import Navbar from '../views/Navbar.vue'
import AboutUs from '../components/AboutUs.vue'
import Promotion from '../components/Promotion.vue'
import Location from '../components/Location.vue'
import Contact from '../components/Contact.vue'
import Staff from '../components/Staff.vue'
import Report from '../components/Report.vue'
// import HomeSetting from '../views/HomeSetting.vue'
// import ProvinceSetting from '../master_data_setting/ProvinceSetting.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login2',
    component: Login
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/forgetpassword',
    name: 'ForgetPassword',
    component: ForgetPassword
  },
  // {
  //   path: '/home',
  //   name: 'HomeSetting',
  //   component: HomeSetting
  // },
  {
    path: '/navbar',
    name: 'Navbar',
    component: Navbar,
    children: [
      {
        path: '/aboutus',
        name: 'AboutUs',
        component: AboutUs
      },
      {
        path: '/promotion',
        name: 'Promotion',
        component: Promotion
      },
      {
        path: '/location',
        name: 'Location',
        component: Location
      }, {
        path: '/contact',
        name: 'Contact',
        component: Contact
      },
      {
        path: '/staff',
        name: 'Staff',
        component: Staff
      },
      {
        path: '/report',
        name: 'Report',
        component: Report
      },

      // {
      //   path: '/province_setting',
      //   name: 'ProvinceSetting',
      //   component: ProvinceSetting
      // },
    ]
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
router.beforeEach((to, from, next) => {
  // console.log("router");
  if (!Vue.prototype.$session.get("token")) {
    if (window.location.pathname == '/' || window.location.pathname == '/login' || window.location.pathname == '/forgetpassword') {
      next();
    }
    else if (to.path != "/" || to.path != "/login" || to.path != 'forgetpassword') {
      window.location.pathname = '/'

    }

  } else {
    // const session time 2 Hour.
    // const sessionTime_DIFFERENCE = 24 * 60 * 60 * 1000;
    const sessionTime_EXPIRE = Vue.prototype.$session.get("token_expired");
    const time_thai_late = 7 * 60 * 60 * 1000
    // const sessionTime_EXPIRE = '2020-07-31 16:27:32.5'
    // old session time
    // var sessionTime_OLD = Vue.prototype.$session.get("sessionTime");
    // now time
    var sessionTime_NOW = new Date().toISOString().substr(0, 10) + ' ' + new Date().toISOString().substr(11, 10);
    // console.log((sessionTime_EXPIRE));
    // console.log(sessionTime_NOW);
    // console.log(Date.parse(sessionTime_EXPIRE) - (Date.parse(sessionTime_NOW) + (time_thai_late)));

    // now - old > diff OR not have session Timeout
    if (
      Date.parse(sessionTime_EXPIRE) - (Date.parse(sessionTime_NOW) + (time_thai_late)) <
      0
    ) {
      Swal.fire(
        "หมดเวลา",
        "หมดเวลา กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
        "warning"
      ).then(result => {
        // console.log("sessionTimeOut");
        Vue.prototype.$session.clear();
        next("/login");
        window.location.reload();
      });
    }
    else {
      // Vue.prototype.$session.set("sessionTime", sessionTime_NOW);
      let role_name = Vue.prototype.$session.get("role")
      if (role_name == "Super Admin") {
        if (to.path == "/" || to.path == "/login" || to.path == 'forgetpassword') {
          next("/promotion")
        } else {
          next()
        }

      }
      else if (role_name == "Admin") {
        if (to.path == "/report" || to.path == "/" || to.path == "/login" || to.path == 'forgetpassword') {
          next("/promotion")

        } else {
          next();
        }
      } else {
        Swal.fire(
          "ไม่สามารถทำรายการต่อได้",
          "กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
          "warning"
        ).then(result => {
          // console.log("sessionTimeOut");
          Vue.prototype.$session.clear();
          next("/login");
          window.location.reload();
        });
      }


    }
  }
});
router.afterEach((to, from) => { });
